import React from 'react';

type ArrowIconProps = {
  size: 'small' | 'large';
};

export const ArrowIcon = ({ size }: ArrowIconProps) => {
  if (size === 'small') {
    return (
      <svg className="arrow" width="16" height="16" viewBox="0 0 16 16" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
        <path d="M7.99984 2.66667L7.05984 3.60667L10.7798 7.33333H2.6665V8.66667H10.7798L7.05984 12.3933L7.99984 13.3333L13.3332 8L7.99984 2.66667Z" />
      </svg>
    );
  }
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
      <path
        d="M1.2085 8.99985H12.3785L7.4985 13.8798C7.1085 14.2698 7.1085 14.9098 7.4985 15.2998C7.8885 15.6898 8.5185 15.6898 8.9085 15.2998L15.4985 8.70985C15.8885 8.31985 15.8885 7.68985 15.4985 7.29985L8.9185 0.699849C8.5285 0.309849 7.8985 0.309849 7.5085 0.699849C7.1185 1.08985 7.1185 1.71985 7.5085 2.10985L12.3785 6.99985H1.2085C0.658496 6.99985 0.208496 7.44985 0.208496 7.99985C0.208496 8.54985 0.658496 8.99985 1.2085 8.99985Z"
        fill="#171717"
      />
    </svg>
  );
};
